<template>
  <div>
    <page-header>
      <template #breadcrumbs>
        <router-link to="/journals">Журнал ЛРАС</router-link> &raquo;
        <template v-if="patient">
          <router-link :to="'/journal/edit/' + patient.id">{{ patient.surname }} {{ patient.name }}
            {{ patient.patronimic }}
          </router-link> &raquo; Карточка ИПРА
        </template>
      </template>
      <h2>Карточка ИПРА</h2>
    </page-header>
    <div class="card">
      <div class="row mt-2">
        <div class="col-md-4">
          <div class="form-group required">
            <label class="control-label">Идентификатор</label>
            <div>
              <component-input :disabled="isReadonly" v-model="card.externalId" :required="true"/>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group required">
            <label class="control-label">Дата формирования</label>
            <div>
              <date-component :disabled="isReadonly" v-model="card.formed" :required="true"/>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group required">
            <label class="control-label">Печатная версия</label>
            <div>
              <file-upload width="100%" :entity="card" :readonly="isReadonly" :required="true"
                           @deleteFile="removeFile"
                           prop-name="file"
                           @uploaded="fileUploaded"/>
            </div>
          </div>
        </div>
      </div>
      <h4>Реквизиты документа</h4>
      <div class="row mt-2">
        <div class="col-md-4">
          <div class="form-group required">
            <label class="control-label">Номер</label>
            <div>
              <component-input :disabled="isReadonly" v-model="card.docNum" :required="true"/>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group required">
            <label class="control-label">Дата</label>
            <div>
              <date-component :disabled="isReadonly" v-model="card.docDate" :required="true"/>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group required">
            <label class="control-label">Срок действия</label>
            <div>
              <date-component :disabled="isReadonly" v-model="card.docValidTo" :required="true"/>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="float-right  d-flex align-items-center">
          <button-component
              class="btn btn-primary mx-2"
              v-on:click="save"
              v-if="!isReadonly"
          >
            Сохранить
          </button-component>
          <button-component type="button" kind="secondary" class="btn btn-default" v-on:click="close">
            Закрыть
          </button-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/common/components/page/PageHeader";
import Api from "../api/ipra";
import JournalApi from "../api/journal";
import RasApi from "@/modules/ras/api/ras";
import DateComponent from "../../../common/components/DateComponent";
import ComponentInput from "../../../common/components/ComponentInput";
import ButtonComponent from "../../../common/ui/ButtonComponent";
import FileUpload from "../../../common/components/FileUpload";
import Constants from "@/common/constants";
import {useVuelidate} from "@vuelidate/core";
export default {
  name: "IpraCard",
  components: {FileUpload, ButtonComponent, ComponentInput, DateComponent, PageHeader},
  data() {
    return {
      patient: null,
      card: null,
      isReadonly: this.$route.params.action === 'view'
    };
  },
  created() {
    this.initCard();
    if (this.$route.params.action !== "add") {
      Api.find(this.$route.params.id).then((response) => {
        this.card = response.data;
      });
    }
  },
  methods: {
    initCard() {
      this.card = {
        id: 0,
        journalId: this.$route.params.journal_id,
        externalId: null,
        formed: this.$momentFormat(new Date(), 'YYYY-MM-DD'),
        docNum: null,
        docDate: null,
        docValidTo: null,
        fileId: null,
        file: null
      };
      JournalApi.getById(this.card.journalId).then((response) => {
        const journal = response.data;
        RasApi.find(journal.patientId).then((response) => {
          this.patient = response.data;
        });
      });
    },
    removeFile() {
      this.card.fileId = null;
      this.card.file = null;
    },
    fileUploaded(e) {
      this.card.file = e.data;
      this.card.fileId = e.data ? e.data.id : null;
    },
    save() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей.', 'error');
        return;
      }
      if (this.card.id) {
        Api.update(this.card.id, this.card).then((response) => {
          if (response.status === 200) {
            Constants.alert.fire('Сохранение', 'Запись ИПРА сохранена.', 'success');
            this.$router.push({name: 'journalCard', params: {action: 'edit', id: this.patient.id, tab: 'tab4'}});
          } else {
            console.log(response);
            Constants.alert.fire('Сохранение', 'При сохранении произошла ошибка. Обратитесь в техническую поддержку.', 'error');
          }
        });
      } else {
        Api.create(this.card).then((response) => {
          if (response.status === 200) {
            Constants.alert.fire('Создание', 'Запись ИПРА создана.', 'success');
            this.$router.push({name: 'journalCard', params: {action: 'edit', id: this.patient.id, tab: 'tab4'}});
          } else {
            console.log(response);
            Constants.alert.fire('Создание', 'При создании записи произошла ошибка. Обратитесь в техническую поддержку.', 'error');
          }
        });
      }
    },
    close() {
      this.$router.push('/journal/edit/' + this.patient.id);
    }
  },
  setup: () => ({v$: useVuelidate()})
}
</script>
<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.form-group.required .control-label:after {
  content:" *";
  color:red;
}
.form-check.required .control-label:after {
  content:" *";
  color:red;
}
.invalid-msg {
  color:red;
  font-size: 0.75rem;
}
.card {
  padding: 24px;
  margin: 10px 24px 0 24px;
  border-radius: 24px;
  border: none;
  box-shadow: none;
  &-footer{
    padding-top: 1rem !important;
    background-color: transparent;
    border: none
  }
}
h4 {
  font-size: 18px;
  margin: 0;
}
</style>